import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import Home from "@/pages/Home";

// Lazy so the public bundle never pays for the admin: the chunk loads only
// when someone actually opens /admin.
const AdminPage = lazy(() => import("@/admin/AdminPage"));

function App() {
  return (
    <div className="App grain">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route
              path="/admin"
              element={
                <Suspense fallback={null}>
                  <AdminPage />
                </Suspense>
              }
            />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" />
      </LanguageProvider>
    </div>
  );
}

export default App;
